import React from "react";
import styled from "styled-components";
import {
  Card,
  Button,
  CardTitle,
  CardImg,
  CardText,
  Row,
  Col,
  Container
} from "reactstrap";

import Fargo_RRG from "./images/Fargo_RRG.png";
import RRG_Bismarck_Web from "./images/RRG_Bismarck_Web.jpg";

const AddressDiv = styled.div`margin: 50px 5px;`;
const LocationDiv = styled.div`
  margin: 15px;
  height: 200px;
`;
const AddressLine = styled.p`
  font-size: 20px;
  line-height: 50%;
`;

class Locations extends React.Component {
  render() {
    return (
      <AddressDiv>
        <Container fluid>
          <Row>
            <Col xs="12" sm="12" md="6">
              <Card>
                <CardImg
                  top
                  width="100%"
                  src={Fargo_RRG}
                  alt="Card image cap"
                />
                <LocationDiv>
                  <CardTitle>Fargo</CardTitle>
                  <CardText>
                    <AddressLine>300 43rd St N</AddressLine>
                    <AddressLine>Fargo, ND 58102</AddressLine>
                    <AddressLine>Phone: (701) 232-4717</AddressLine>
                  </CardText>
                  <Button
                    color="primary"
                    href="https://www.google.com/maps/place/Red+River+Glazing+Inc/@46.881019,-96.8560856,15z/data=!4m5!3m4!1s0x0:0x783a9f7dd26ed695!8m2!3d46.881019!4d-96.8560856"
                    target="_blank"
                  >
                    Map
                  </Button>
                </LocationDiv>
              </Card>
            </Col>
            <Col xs="12" sm="12" md="6">
              <Card>
                <CardImg
                  top
                  width="100%"
                  src={RRG_Bismarck_Web}
                  alt="Card image cap"
                />
                <LocationDiv>
                  <CardTitle>Bismarck</CardTitle>
                  <CardText>
                    <AddressLine>1365 Tacoma Avenue</AddressLine>
                    <AddressLine>Unit 6</AddressLine>
                    <AddressLine>Bismarck, ND 58504</AddressLine>
                    <AddressLine>Phone: (701) 751-0694</AddressLine>
                  </CardText>
                  <Button
                    color="primary"
                    href="https://www.google.com/maps/place/Red+River+Glazing/@46.782189,-100.770234,15z/data=!4m5!3m4!1s0x0:0x4cb741a28b1d20eb!8m2!3d46.782189!4d-100.770234"
                    target="_blank"
                  >
                    Map
                  </Button>
                </LocationDiv>
              </Card>
            </Col>
          </Row>
        </Container>
      </AddressDiv>
    );
  }
}

export default Locations;



// WEBPACK FOOTER //
// ./src/Locations.js